import React, {Context, createContext, useContext, useEffect, useState} from "react";

type WindowSizeContextType = {
    width: number;
    height: number;
    isMobile: boolean;
}

const WindowSizeContext: Context<WindowSizeContextType> = createContext<WindowSizeContextType>({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth < 1200,
});

export const WindowSizeProvider = ({ children }: { children: React.ReactNode }) => {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 1200);

    useEffect(() => {
        const handleResize = () => {
            const widthTmp = window.innerWidth;
            const heightTmp = window.innerHeight;
            setSize({
                width: widthTmp,
                height: heightTmp,
            });
            setIsMobile(widthTmp < 1200);
        };

        // Calcul initial
        handleResize();

        window.addEventListener("resize", handleResize);
        document.addEventListener("fullscreenchange", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            document.removeEventListener("fullscreenchange", handleResize);
        }
    }, []);

    const exposedValue: WindowSizeContextType = {
        width: size.width,
        height: size.height,
        isMobile
    }

    return <WindowSizeContext.Provider value={exposedValue}>{children}</WindowSizeContext.Provider>;
};

export const useWindowSizeContext = (): WindowSizeContextType => useContext(WindowSizeContext);